import { Button, CircularProgress } from "@mui/material"
import { Box } from "@mui/system"
import { useState } from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import MessageModal from "../../../components/MessageModal"
import { useAuth } from "../../../contexts/AuthContext"
import useAxiosPrivate from "../../../hooks/useAxiosPrivate"
import { deleteUserProfile } from "../services/profileService"
import { useMutation } from "@tanstack/react-query"
import useLogout from "../../../hooks/useLogout"

export default function DeleteProfile() {
    const [open, setOpen] = useState(false)
    const [message, setMessage] = useState(null)
    const [deleteDisabled, setDeleteDisabled] = useState(false)
    const axiosPrivate = useAxiosPrivate()
    const { auth } = useAuth()
    const { clearUser } = useLogout()
    const { mutate } = useMutation({
        mutationFn: () =>
            deleteUserProfile({ axiosPrivate, token: auth?.token }),
        onSuccess: () => {
            // localStorage.clear()
            // sessionStorage.clear()
            clearUser()
            setMessage({
                type: `Sarwatch Terminated`,
                text: "Your profile information has been removed. Sorry to see you go.",
                navigateTo: "/",
                replace: false,
            })
            setOpen(false)
        },
        onError: (error) => {
            setMessage({
                type: "Unable to comply...",
                text:
                    error ||
                    "An error occurred while deleting the profile. Please try again later.",
            })
        },
        onSettled: () => {
            setDeleteDisabled(false)
        },
    })

    function handleClickDelete() {
        setOpen(true)
    }

    function handleClose() {
        setOpen(false)
    }

    async function handleDeleteConfirmed() {
        setDeleteDisabled(true)
        return mutate()
    }

    const dialogText = `Warning! This action is permanent and will cancel any trial or subscription immediately. You will no longer have access to Aircrew Port Pages. If you would like to cancel your subscription or trial but still have access until the specified period ends, select Manage Subscription -> Cancel Subscription. Again, this action cannot be undone...`

    return (
        <Box sx={{ width: { xs: "100%", sm: "fit-content" } }}>
            {
                <Button
                    sx={{
                        width: { xs: "100%", sm: "fit-content" },
                    }}
                    color="error"
                    onClick={handleClickDelete}
                    variant="outlined"
                    disabled={deleteDisabled}
                    startIcon={
                        deleteDisabled ? (
                            <CircularProgress size={20} />
                        ) : (
                            <DeleteForeverIcon />
                        )
                    }
                >
                    DELETE PROFILE
                </Button>
            }
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <Box sx={{ backgroundColor: "transparent" }}>
                    <DialogTitle id="alert-dialog-title">
                        {"Delete Profile?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} autoFocus>
                            CANCEL
                        </Button>
                        <Button
                            color="error"
                            variant="contained"
                            startIcon={<DeleteForeverIcon />}
                            onClick={handleDeleteConfirmed}
                        >
                            DELETE
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>
            {message && (
                <MessageModal message={message} setMessage={setMessage} />
            )}
        </Box>
    )
}
